export enum ETypeSlice {
  HOSTS,
  GROUPS,
}
export enum EVariantSlice {
  PROCEEDS,
  TIME,
}

export type TDataByCategory = {
  time: number;
  percentTime: number;
  proceeds: number;
};
export type TNormalizedItem = {
  alias: string;
  groupTitle: string;
  clients: TDataByCategory;
  guests: TDataByCategory;
  total: TDataByCategory;
  averageSessionTime: number;
  sessionsCount: number;
  hostCount?: number;
};

export interface ISummaryData {
  totalTime: number;
  occupationTime: number;
  occupationPercentage: number;
  sessionsCount: number;
  averageSessionsTime: number;
  money: number;
}
